import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "page-header" }
const _hoisted_5 = { class: "page-content" }

import store from "@/store";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  svgIcon,
  mobileHeader,
  footerMenu,
  mobileMenu,
  fullLoading,
} from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
  active?: boolean;
}

const headerHeight = "4rem";
const titleHeight = "4rem";
const footerHeight = "4rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  props: {
    accountId: {},
    tabActive: {},
    menuList: {},
    showHome: { type: Boolean, default: true },
    showBack: { type: Boolean, default: false },
    backUrl: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v388c2cf0": (headerHeight),
  "v54f550aa": (titleHeight),
  "v4590ba16": (footerHeight)
}))

const { t } = useI18n();

const props = __props;

const mobileMenuOpen = ref<string | null>(null);

const footerMenuList = computed(() => {
  const list: MenuListType[] = [
    {
      key: "menu",
      icon: "grid",
      label: t("common.labels.menu"),
    },
    {
      key: "alert",
      icon: "alert",
      label: t("common.labels.alert"),
    },
  ];

  if (props.showHome && !props.showBack)
    list.unshift({
      key: "home",
      icon: "home-line",
      label: t("common.labels.home"),
      url: `/${props.accountId}/home`,
    });

  if (!props.showHome && props.showBack)
    list.unshift({
      key: "back",
      icon: "arrows-left",
      label: t("common.labels.back"),
      url: props.backUrl,
      active: false,
    });

  return list;
});

function openFooterMenu(value: any) {
  mobileMenuOpen.value = value.key;
}

function menuMobileClose() {
  mobileMenuOpen.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(mobileHeader), { height: headerHeight }),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _createElementVNode("section", _hoisted_5, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ]),
      _createVNode(_unref(footerMenu), {
        "menu-list": footerMenuList.value,
        height: footerHeight,
        onOpen: openFooterMenu
      }, null, 8, ["menu-list"])
    ]),
    (_unref(store).getters.loading)
      ? (_openBlock(), _createBlock(_unref(fullLoading), { key: 0 }))
      : _createCommentVNode("", true),
    (mobileMenuOpen.value === 'menu')
      ? (_openBlock(), _createBlock(_unref(mobileMenu), {
          key: 1,
          "menu-list": __props.menuList,
          active: __props.tabActive,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (menuMobileClose()))
        }, null, 8, ["menu-list", "active"]))
      : _createCommentVNode("", true)
  ]))
}
}

})